import React from 'react';
import { List } from '@cko/primitives';

import { useNavigation } from '../../providers';
import { AccessibleGap, NavContainer, Wrapper } from './SideBar.styles';
import { SideNavMenuProvider, SideNavLevelOneGrouping } from './SideNavMenu';
import { SideNavMenuItemLink } from './SideNavMenu/SideNavMenuItemLink';

export const SideBar = () => {
  const { filteredMenuItems } = useNavigation();
  const domainAgnosticMenuItems = filteredMenuItems.domain_agnostic;
  const domainsMenuItems = filteredMenuItems.domain_specific;

  const showDomainAgnosticMenuItems = domainAgnosticMenuItems?.length > 0;
  const showDomainsMenuItems = domainsMenuItems?.length > 0;
  const showMenu = showDomainAgnosticMenuItems || showDomainsMenuItems;
  if (!showMenu) {
    return null;
  }

  return (
    <Wrapper>
      <NavContainer>
        <SideNavMenuProvider>
          <List>
            {showDomainAgnosticMenuItems && (
              <>
                {domainAgnosticMenuItems.map((menuItem) => {
                  if (menuItem.type === 'group') {
                    return (
                      <SideNavLevelOneGrouping key={menuItem.label} menuItemConfig={menuItem} />
                    );
                  }

                  if (menuItem.type === 'internal_link') {
                    return (
                      <SideNavMenuItemLink
                        key={menuItem.label}
                        menuItemConfig={menuItem}
                        level={1}
                      />
                    );
                  }

                  return null;
                })}
                {/* Add empty element with required spacing between menu items sections so that screen readers correctly state number of items in menu list */}
                <AccessibleGap />
              </>
            )}
            {showDomainsMenuItems &&
              domainsMenuItems.map((menuItem) => {
                if (menuItem.type === 'group') {
                  return <SideNavLevelOneGrouping key={menuItem.label} menuItemConfig={menuItem} />;
                }

                if (menuItem.type === 'internal_link') {
                  return (
                    <SideNavMenuItemLink key={menuItem.label} menuItemConfig={menuItem} level={1} />
                  );
                }

                return null;
              })}
          </List>
        </SideNavMenuProvider>
      </NavContainer>
    </Wrapper>
  );
};
